module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA/ElEQVQ4jbWTsWoCURBF74iFJAQJIWDa1H5BtrAJ/kLqpE6Zwj/ID6QMWFtYWNqGdHY2VrZpgiKxCFh4wpN5IIu7SXx6YR/s7J3DnWWeDiUDhpIySes9mBVJYzO7qUq6lHSaEOxkcwLhuWc/PYb+CBoAZ0AGLP+IWwFtoAJ0Iyiq4ekmv0Cm7qsB38RIwHzLdOem1wJIz7/fbtU+I2iRMz+7+SFXf/J6J1efFYGC3rypCYyAlr8PdnhLQfjIVw6o+r/ZpVlcqCKdS/qQ9CLpS9J12TKFzV5Iqics5NzMLsoS/UsBZImMTX8YjdQ0Zmbh0vYltRM476lBjiBJP+0a0hWJWnqzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/X4.png
// module id = DpHe
// module chunks = 42